angular.module('impactx.cscontract').controller('CSCCommentsCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCCommentsCtrl
]);

function CSCCommentsCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {commentsData: $scope.data}, "/cscontract/comments/save").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'csccomments', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/comments/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}